import createEmojiRegex from "emoji-regex";

import Emoji from "~/components/common/Emoji";
import { isNotNullable } from "~/utils/common";

import getAllMatches from "../regexp/getAllMatches";

const EMOJI_REGEXP = createEmojiRegex();

export const getSeparatedTextAndEmojis = (
  text: string
): (string | JSX.Element)[] => {
  const emojis = getAllMatches(text, EMOJI_REGEXP);

  if (!emojis.length) {
    return [text];
  }

  const parts = [];
  let previousMatchEnd = -1;

  for (let i = 0; i < emojis.length; i++) {
    const index = emojis[i].index;

    if (isNotNullable(index)) {
      const textPart = text.slice(previousMatchEnd + 1, index);
      parts.push(textPart);

      const matchPart = emojis[i][0];
      parts.push(<Emoji key={i} native={matchPart} />);

      previousMatchEnd = index + matchPart.length - 1;
    }
  }

  if (previousMatchEnd < text.length - 1) {
    parts.push(text.slice(previousMatchEnd + 1));
  }

  return parts;
};
